import { Vector3 } from "three";

/** How far above the screen centre the anchor (the Sun, or a moon's planet) appears. */
export const ANCHOR_ANGLE = (20 * Math.PI) / 180;

const FALLBACK_UP = new Vector3(1, 0, 0);
const screenUp = new Vector3();

/**
 * Unit offset from the focused body to the camera so the body sits centred and
 * the anchor appears `angle` straight above it. `anchorDir` (body → anchor) and
 * `up` are unit vectors.
 */
export function framingOffset(
  anchorDir: Vector3,
  up: Vector3,
  angle: number,
  out: Vector3,
): Vector3 {
  // the part of `up` across the anchor line is screen up; it vanishes when the
  // anchor sits straight above or below, so lean on a fixed sideways axis there
  screenUp.copy(up).addScaledVector(anchorDir, -up.dot(anchorDir));
  if (screenUp.lengthSq() < 1e-6)
    screenUp.copy(FALLBACK_UP).addScaledVector(anchorDir, -FALLBACK_UP.dot(anchorDir));
  screenUp.normalize();
  // the camera looks `angle` below the anchor, so it sits behind the body and above it
  return out
    .copy(screenUp)
    .multiplyScalar(Math.sin(angle))
    .addScaledVector(anchorDir, -Math.cos(angle));
}

/**
 * Tilt between the anchor line and the view that shows a near anchor at `angle`
 * from a camera `ratio` (camera distance / anchor distance) behind the body.
 */
export function framingAngle(angle: number, ratio: number): number {
  return angle + Math.asin(Math.min(1, ratio * Math.sin(angle)));
}
